import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { APICallService } from 'src/app/services/api-call.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';


@Component({
  selector: 'typhoon-zone-lov',
  templateUrl: './typhoon-zone-lov.component.html',
  styleUrls: ['./typhoon-zone-lov.component.css']
})
export class TyphoonZoneLovComponent implements OnInit {

  private typhoonZoneModuleId: string = 'BMM189';
  private selectedData: any;
  public titleLov: string = "Typhoon Zoning".toUpperCase();

  typhoonZoneTable: any = {
    cols: [],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  };
  private typhoonZoneTableCol: any[] = [
    {
      key: "TYPHOON_ZONE_CD",
      header: "Code",
      dataType: "string"
    },
    {
      key: "TYPHOON_LONG_DESC",
      header: "Description",
      dataType: "string"
    },
  ];
  private typhoonZoneTablePlanCol: any[] = [
    {
      key: "TYPHOON_ZONE_CD",
      header: "Code",
      dataType: "string"
    },
    {
      key: "TYPHOON_LONG_DESC",
      header: "Plan",
      dataType: "string"
    },
  ];
  constructor(
    private jsonDataService: JsonDataService,
    private dialogRef: MatDialogRef<TyphoonZoneLovComponent>,
    private _api: APICallService,
    private securityService: SecurityService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    @Inject(MAT_DIALOG_DATA) public fromMainData: any,
  ) {
    if("title" in this.fromMainData){
      this.titleLov = this.fromMainData.title;
    }
    if("tableData" in this.fromMainData){
      if(this.fromMainData.tableData == "PLAN"){
        this.typhoonZoneTable.cols = this.typhoonZoneTablePlanCol;
        this.getTyphoonZoneData();
      }
      else{
        this.typhoonZoneTable.cols = this.typhoonZoneTableCol;
        this.getTyphoonZoneData();
      }
    }
    else{
      this.typhoonZoneTable.cols = this.typhoonZoneTableCol;
      this.getTyphoonZoneData();
    }
    
  }

  ngOnInit(): void {
  }

  onRowClick(ev: any) {
    try {
      this.selectedData = ev;
    } catch (e) {
    console.error(e);

    }
  }

  private getTyphoonZoneData(): void {
    try {
      this.typhoonZoneTable.loading = true;
      this.jsonDataService.contorlLoading(true);
      this._api.getTyphoonZoning({
        moduleId: this.fromMainData.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe({
        next: (data: any) => {
          this.securityService.checkRequestKeyResponse(data, () => {
            this.securityService.hasValidCsrfToken(data, () => {
              let content = JSON.parse(this.jsonDataService.decrypt(data?.response));
              if (content.moduleId === this.typhoonZoneModuleId) {
                this.jsonDataService.contorlLoading(false);
                this.typhoonZoneTable.tblData = content.data?.filter((e: any) => e.ACTIVE_TAG == 'A') ?? [];
                this.typhoonZoneTable.loading = false;
              } else {
                this.typhoonZoneTable.loading = false;
                this.jsonDataService.contorlLoading(false);
                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
              }
            });
          });
        },
        error: (e: any) => {
          this.securityService.checkRequestKeyResponse(e, () => {

            this.typhoonZoneTable.loading = false;
            this.jsonDataService.contorlLoading(false);
            this.appMessageService.showAppMessage(e, "error");
          });
        }
      });
    }
    catch (e) {
    console.error(e);

      this.typhoonZoneTable.loading = false;
      this.jsonDataService.contorlLoading(false);
    }
  }

  onClose(str: string) {
    try {
      if (this.selectedData == '' || this.selectedData == null) {
        this.dialogRef.close({ content: '', button: str });
      }
      else {
        this.dialogRef.close({ content: this.selectedData, button: str });
      }
    } catch (e) {
    console.error(e);

    }
  }

}
